import { render } from "./JamyeList.vue?vue&type=template&id=50001d9c"
import script from "./JamyeList.vue?vue&type=script&lang=js"
export * from "./JamyeList.vue?vue&type=script&lang=js"

import "./JamyeList.vue?vue&type=style&index=0&id=50001d9c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__